// Color helpers for sensors: hashing + HSL->hex conversion
export function fnv1a32(str) {
	let h = 2166136261 >>> 0;
	for (let i = 0; i < str.length; i++) {
		h ^= str.charCodeAt(i);
		h = Math.imul(h, 16777619) >>> 0;
	}
	return h >>> 0;
}

export function hslToHex(h, s, l) {
	s /= 100; l /= 100;
	const k = n => (n + h / 30) % 12;
	const a = s * Math.min(l, 1 - l);
	const f = n => {
		const t = k(n);
		const c = l - a * Math.max(Math.min(t - 3, 9 - t, 1), -1);
		return Math.round(255 * c);
	};
	const r = f(0), g = f(8), b = f(4);
	return (r << 16) | (g << 8) | b;
}

export function getSensorColor(sensor) {
	const key = (sensor && (sensor.label || sensor.id) ? (sensor.label || sensor.id) : '').toString();
	const h32 = fnv1a32(key.repeat(10));
	const n = (h32 >>> 0) / 0xFFFFFFFF;
	const GOLDEN = 0.618033988749895;
	const hueFrac = (n * GOLDEN) % 1;
	const hue = Math.floor(hueFrac * 360);
	const sat = 60 + (h32 & 15);
	const light = 65 + ((h32 >>> 4) & 15);
	return hslToHex(hue, sat, light);
}

export default { fnv1a32, hslToHex, getSensorColor };
